/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { bool, object, string } from 'prop-types';
import cn from 'classnames';
import { scrollTo } from 'scroll-js';

import { GuideSynopsisIcon } from '../../elements/Icons';
import styles from './GuideSynopsis.module.scss';

const mapStateToProps = (state) => ({
  pageIsMounted: state.swaggerApi.pageIsMounted,
  guidePostLoading: state.ghost.guidePostLoading,
  sdkPostLoading: state.ghost.sdkPostLoading,
  selectedVersion: state.swaggerApi.selectedVersion,
});

const mapDispatchToProps = {};

GuideSynopsis.propTypes = {
  router: object,
  pathName: string,
  pageIsMounted: bool,
  guidePostLoading: bool,
  sdkPostLoading: bool,
};

function GuideSynopsis(props) {
  const [tags, setTags] = useState(null);
  const [title, setTitle] = useState('');
  const [activeIndex, setIndexTag] = useState(0);
  const [tagsCoordinates, setCoordinates] = useState(0);
  const [isActiveScroll, toggleScroll] = useState(true);
  const { pageIsMounted, guidePostLoading, sdkPostLoading, selectedVersion } = props;
  const location = useLocation();
  const headerHeight = 40;

  useEffect(() => {
    const pathName = location.pathname;
    if (pathName.indexOf('/apis') !== -1) {
      setTitle('api synopsis');
    }
    if (pathName.indexOf('/guides') !== -1) {
      setTitle('guide synopsis');
    }
    if (pathName.indexOf('/sdks') !== -1) {
      setTitle('sdk synopsis');
    }
  }, [location]);

  useEffect(() => {
    if (pageIsMounted) {
      getGuideLinks();
    } else {
      setTags(null);
      setIndexTag(0);
    }
  }, [location, pageIsMounted]);

  useEffect(() => {
    const isGuidePage = location.pathname.indexOf('/guides') !== -1;
    if (isGuidePage && !guidePostLoading) {
      getGuideLinks();
    }
  }, [location, guidePostLoading]);

  useEffect(() => {
    const isApisPage = location.pathname.indexOf('/apis') !== -1;
    if (isApisPage && pageIsMounted) {
      getGuideLinks();
    }
  }, [location, selectedVersion, pageIsMounted]);

  useEffect(() => {
    const isSdkPage = location.pathname.indexOf('/sdks') !== -1;
    if (isSdkPage && !sdkPostLoading) {
      getGuideLinks();
    }
  }, [location, sdkPostLoading]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleScroll() {
    if (isActiveScroll) {
      const scrollTop = window.scrollY;
      const docHeight = document.body.clientHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = (scrollTop) / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent*100);

      const closest = tagsCoordinates.reduce((prev, curr) => {
        const a = prev.y || 0;
        const b = curr.y || 0;
        let aDiff = Math.abs(a - scrollPercentRounded);
        let bDiff = Math.abs(b - scrollPercentRounded);

        if (aDiff == bDiff) {
          return a < b ? prev : curr;
        } else {
          return bDiff < aDiff ? curr : prev;
        }
      });

      setIndexTag(closest.index);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  function getGuideLinks() {
    setTimeout(() => {
      const box = document.querySelector('.js-docs-box');
      const allOperationTags = box.querySelectorAll('h1, h2, h3');

      if (!!allOperationTags.length) {
        setTags(allOperationTags);
        setTagsCoordinates(allOperationTags);
      } else {
        setTags(null);
      }
    }, 200);
  }

  function setTagsCoordinates(tags) {
    const cordinates = [];
    const winHeight = document.body.clientHeight;

    tags.forEach((tag, index) => {
      const rectTop = tag.getBoundingClientRect().top;
      const position = (rectTop * 100)/winHeight;
      cordinates.push({ index, y: position });
    });
    setCoordinates(cordinates);
  }

  function scrollToElement(el, index) {
    const rect = el.getBoundingClientRect();
    const shift = rect.top + window.scrollY - headerHeight - 10;

    scrollTo(window, { top: shift })
    .then(function () {
      setIndexTag(index);
    })
    .finally(() => {
      setTimeout(() => {
        toggleScroll(true);
      }, 500);
    });
  }

  if (!tags) return null;
  return (
    <div className={styles.guide}>
      <div className={styles.guide__header}>
        <div className={styles.guide__icon}>
          <GuideSynopsisIcon />
        </div>
        <div className={styles.guide__title}>{title}</div>
      </div>
      <ul className={styles.guide__list}>
        {!!tags && [...tags].map((tag, index) => {
          const tagName = tag.textContent || '';
          return (
            <li
              key={index}
              className={cn(styles.guide__link, {
                [styles['guide__link--active']]: activeIndex === index,
              })}
              onClick={() => {
                toggleScroll(false);
                scrollToElement(tag, index);
              }}
            >
              {tagName}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GuideSynopsis);
